import { render, staticRenderFns } from "./ProductDescriptors.vue?vue&type=template&id=43a3ddaf&"
import script from "./ProductDescriptors.vue?vue&type=script&lang=js&"
export * from "./ProductDescriptors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports